import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { focusVisible } from '../../shared/global.styles.js';
import { EButtonSize } from './CgButton.types.js';
import { theme } from '@citygross/design-tokens';
import { Link } from 'react-router-dom';

var _a, _b, _c, _d, _e;

var sharedButtonStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ", "px;\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  height: ", ";\n  width: ", ";\n  padding: ", ";\n  transition: background-color 0.3s ease;\n  white-space: nowrap;\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  ", "\n"], ["\n  border: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ", "px;\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  height: ", ";\n  width: ", ";\n  padding: ", ";\n  transition: background-color 0.3s ease;\n  white-space: nowrap;\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  ", "\n"])), function (_a) {
  var _b;

  var border = _a.border;
  return border ? "1px solid ".concat((_b = theme.palette) === null || _b === void 0 ? void 0 : _b.placeholder) : 'none';
}, function (_a) {
  var _b, _c, _d;

  var circle = _a.circle,
      rounded = _a.rounded;
  return circle ? (_b = theme.attributes) === null || _b === void 0 ? void 0 : _b.borderRadius.circle : rounded ? "".concat((_c = theme.attributes) === null || _c === void 0 ? void 0 : _c.borderRadius.rounded, "px") : "".concat((_d = theme.spacings) === null || _d === void 0 ? void 0 : _d.xxs, "px");
}, function (_a) {
  var _b, _c;

  var boxShadow = _a.boxShadow,
      size = _a.size;
  return boxShadow ? size === EButtonSize.small ? (_b = theme.attributes) === null || _b === void 0 ? void 0 : _b.boxShadow.layoutShadowInset : (_c = theme.attributes) === null || _c === void 0 ? void 0 : _c.boxShadow.layoutShadowInsetMedium : 'none';
}, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor;
}, function (_a) {
  var fontColor = _a.fontColor;
  return fontColor;
}, (_a = theme.spacings) === null || _a === void 0 ? void 0 : _a.xs, (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.type.primary, function (_a) {
  var fontSize = _a.fontSize;
  return fontSize;
}, (_d = (_c = theme.typography) === null || _c === void 0 ? void 0 : _c.weight) === null || _d === void 0 ? void 0 : _d.medium, function (_a) {
  var circle = _a.circle,
      height = _a.height;
  return !circle ? "".concat(height, "px") : 'max-content';
}, function (_a) {
  var fullWidth = _a.fullWidth;
  return fullWidth ? '100%' : 'max-content';
}, function (_a) {
  var circle = _a.circle,
      paddingX = _a.paddingX,
      paddingY = _a.paddingY;
  return circle ? "".concat(paddingY, "px") : "".concat(paddingY, "px ").concat(paddingX, "px");
}, function (_a) {
  var backgroundActive = _a.backgroundActive;
  return backgroundActive;
}, function (_a) {
  var backgroundHover = _a.backgroundHover;
  return backgroundHover;
}, focusVisible);
var Button = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  cursor: pointer;\n\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: default;\n  }\n"], ["\n  ", "\n\n  cursor: pointer;\n\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: default;\n  }\n"])), sharedButtonStyles, function (_a) {
  var backgroundDisabled = _a.backgroundDisabled;
  return backgroundDisabled;
}, (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.placeholder);
styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  text-decoration: none;\n"], ["\n  ", "\n  text-decoration: none;\n"])), sharedButtonStyles);
var CgReactRouterLinkAsButton = styled(Link)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  text-decoration: none;\n"], ["\n  ", "\n  text-decoration: none;\n"])), sharedButtonStyles);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
export { Button, CgReactRouterLinkAsButton };